import { ChangeEvent } from "react";
import { useIntl } from "react-intl";
import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { StyledEmptyWrapper } from "@framework/styled";
import { IReferralTree } from "@framework/types";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";

import { ReferralTreeSearchForm } from "./search";
import { referralTreeColumnsCreator } from "./schemas";

export const ReferralTree = () => {
  const { isLoading, take, skip, onChangePage, allRows, totalCount } = useFetchQuery<IPaginationResult<IReferralTree>>(
    "/referral/tree",
    void 0,
    void 0,
    {
      merchantIds: [],
    },
  );

  const { formatMessage } = useIntl();

  const columns = referralTreeColumnsCreator(formatMessage);

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "referral", "referral.tree"]} />

      <PageHeader message="pages.referral.tree.title" />

      <ReferralTreeSearchForm />

      <ProgressOverlay isLoading={isLoading}>
        <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
          <DataGrid
            pagination
            paginationMode="server"
            rowCount={totalCount}
            paginationModel={{ page: skip / take, pageSize: take }}
            onPaginationModelChange={({ page }) => onChangePage({} as ChangeEvent<unknown>, page)}
            pageSizeOptions={[5, 10, 25, 100]}
            loading={isLoading}
            columns={columns}
            rows={allRows.map((tree: IReferralTree, idx) => ({
              id: idx,
              wallet: tree.wallet,
              referral: tree.referral,
              level: tree.level,
            }))}
          />
        </StyledEmptyWrapper>
      </ProgressOverlay>
    </Grid>
  );
};
